import React from 'react';
import PropTypes from 'prop-types';

const FreightOptions = (props) => {
    return (
        <div id="freightOptions" className="fele-content">
            {props.fOptions.map((option, i) => (
                <div className="form-check" key={i}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={`custom-checkbox-${i}`}
                        value={option.description}
                        checked={props.selectedFreightOptions.includes(option.description)}
                        onChange={() => props.freightOptionUpdated(option.description)}
                    />

                    <label className="form-check-label" htmlFor={`custom-checkbox-${i}`}>
                        {option.description}
                    </label>
                </div>
            ))}
        </div>
    );
};

FreightOptions.propTypes = {
    fOptions: PropTypes.array,
    freightOptionUpdated: PropTypes.func,
    selectedFreightOptions: PropTypes.array,
};

export default FreightOptions;